/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ExchangeRateStatusEnum {
    Active = 100,
    IsEditedByNotOwner = -300,
    Removed = -200,
    Blocked = -100,
}
